import { useApi } from "./api";

export interface WorkLogEntry {
  id: string;
  worker_id: string;
  worker_name: string;
  status: string;
  started_at: string | null;
  completed_at: string | null;
  result: string | null;
  error: string | null;
  created_at: string | null;
}

export interface WorkLogResponse {
  count: number;
  work_log: WorkLogEntry[];
}

export function useWorkLogService() {
  const api = useApi();

  return {
    /**
     * Get all work log entries
     */
    async getWorkLogs(): Promise<WorkLogEntry[]> {
      const response = await api.get<WorkLogResponse>("/bff/work-log/");
      return response.work_log;
    },
  };
}
